import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IUploadOrganizationStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;    
    lsOrgsTxt: string;
    lsUploadTxt: string;
    lsUploadOrgTxt: string;
    lsSelectCSVTxt: string;
    lsFirstRowHeaderChkBoxTxt: string;
    lsRowHeaderTxt: string;
    lsRowHeaderColTxt: string;
    lsCSVUploadInfoTxt1: string;
    lsCSVUploadInfoTxt2: string;
    lsCSVUploadInfoTxt3: string;
    lsCSVUploadInfoTxt4: string;
    lsUploadErrorTxt: string;
    lsClearTxt: string;
    lsHereTxt: string;
}

let strings: IUploadOrganizationStrings;
export default strings = new LocalizedStrings({
    en: {
        lsHomeTxt: 'Home',
        lsOrgsTxt: 'Organizations',
        lsUploadTxt: 'Upload',
        lsUploadOrgTxt: 'Upload New Organizations',
        lsSelectCSVTxt: 'Select the csv file of organizations to upload',
        lsFirstRowHeaderChkBoxTxt: 'First row is header',
        lsRowHeaderTxt: 'Each row in the file must contain values for these columns: ',
        lsRowHeaderColTxt: 'Name, Contact First Name, Contact Last Name, Contact Phone, Contact Email',
        lsCSVUploadInfoTxt1: 'CSV stands for Comma Separated Values, and it\'s a file format (.csv) for spreadsheets.\
        A CSV file is a text file where each column is separated using a comma (,).',
        lsCSVUploadInfoTxt2: 'You can download a sample file from {0} here.\
        Although it can be viewed in Excel to better understand how to construct the CSV\
        file format save it and then use a text editor like Notepad to open the csv file.',
        lsCSVUploadInfoTxt3: 'The sample file when opened in at text editor like Notepad or TextEdit will look like:',
        lsCSVUploadInfoTxt4: 'Then sample file when opened in spreadsheet will look like:',
        lsUploadErrorTxt: 'Issues were found in the below listed rows:',
        lsClearTxt: 'Clear',
        lsHereTxt: 'here'
    },
    es: {
        lsHomeTxt: 'Casa',
        lsOrgsTxt: 'Organizaciones',
        lsUploadTxt: 'Upload',
        lsUploadOrgTxt: 'Subir nuevas organizaciones',
        lsSelectCSVTxt: 'Seleccione el archivo csv de organizaciones para cargar',
        lsFirstRowHeaderChkBoxTxt: 'La primera fila es encabezado',
        lsRowHeaderTxt: 'Cada fila en el archivo debe contener valores para estas columnas: ',
        lsRowHeaderColTxt: 'Name, Contact First Name, Contact Last Name, Contact Phone, Contact Email',
        lsCSVUploadInfoTxt1: 'CSV stands for Comma Separated Values, and it\'s a file format (.csv) for spreadsheets.\
        A CSV file is a text file where each column is separated using a comma (,).',
        lsCSVUploadInfoTxt2: 'You can download a sample file from {0} here.\
        Although it can be viewed in Excel to better understand how to construct the CSV\
        file format save it and then use a text editor like Notepad to open the csv file.',
        lsCSVUploadInfoTxt3: 'The sample file when opened in at text editor like Notepad or TextEdit will look like:',
        lsCSVUploadInfoTxt4: 'Then sample file when opened in spreadsheet will look like:',
        lsUploadErrorTxt: 'Issues were found in the below listed rows:',
        lsClearTxt: 'Clear',
        lsHereTxt: 'here'
    }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/organization/string.organization.upload.tsx